<!-- =========================================================================================
  File Name: DashboardAnalytics.vue
  Description: Dashboard Analytics
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->

<template>
  <div id="dashboard-analytics">
    <div class="vx-row">
      <!-- CARD 1: CONGRATS -->
      <div class="vx-col w-full mb-5">
        <vx-card slot="no-body" class="text-center bg-primary-gradient greet-user">
          <img
            src="@/assets/images/elements/decore-left.png"
            class="decore-left"
            alt="Decore Left"
            width="200"
          />
          <img
            src="@/assets/images/elements/decore-right.png"
            class="decore-right"
            alt="Decore Right"
            width="175"
          />
          <feather-icon
            icon="AwardIcon"
            class="p-4 mb-5 bg-primary inline-flex rounded-full text-white shadow"
            svgClasses="h-6 w-6"
          ></feather-icon>
          <h1 class="mb-2 text-white">
            <template v-if="activeUserInfo.displayName">
            "{{ activeUserInfo.displayName }}" عزیز خوش آمدید 
            </template>
            <template v-else>
            کاربر گرامی خوش آمدید
            </template>
            
            </h1>
          <p class="xl:w-3/4 lg:w-4/5 md:w-2/3 w-4/5 mx-auto text-white">
            <!-- مجموع پرداخت های دریافتی امروز :
            <strong>{{ checkpointReward.progress }}</strong> تومان-->
          </p>
        </vx-card>
      </div>
    </div>
    <div class="vx-row">
      <!-- CARD 9: DISPATCHED ORDERS -->
      <div class="vx-col w-full">
        <vx-card title="آخرین تراکنش‌ها">
          <div slot="no-body" class="mt-4">
            <last-transactions :OnlyConsumer="true"></last-transactions>
          </div>
        </vx-card>
      </div>
    </div>
  </div>
</template>

<script>
import VueApexCharts from "vue-apexcharts";
import StatisticsCardLine from "@/components/statistics-cards/StatisticsCardLine.vue";
import analyticsData from "./ui-elements/card/analyticsData.js";
import ChangeTimeDurationDropdown from "@/components/ChangeTimeDurationDropdown.vue";
import VxTimeline from "@/components/timeline/VxTimeline";
import LastTransactions from "@/views/bpay/transaction/LastTransactions.vue";

export default {
  name:"consumer-home",
  data() {
    return {
      myBalance: "0",
      checkpointReward: {},
      subscribersGained: {},
      ordersRecevied: {},
      salesBarSession: {},
      supportTracker: {},
      productsOrder: {},
      salesRadar: {},

      timelineData: [
        {
          color: "primary",
          icon: "PlusIcon",
          title: "Client Meeting",
          desc: "Bonbon macaroon jelly beans gummi bears jelly lollipop apple",
          time: "25 mins Ago"
        },
        {
          color: "warning",
          icon: "MailIcon",
          title: "Email Newsletter",
          desc: "Cupcake gummi bears soufflé caramels candy",
          time: "15 Days Ago"
        },
        {
          color: "danger",
          icon: "UsersIcon",
          title: "Plan Webinar",
          desc: "Candy ice cream cake. Halvah gummi bears",
          time: "20 days ago"
        },
        {
          color: "success",
          icon: "LayoutIcon",
          title: "Launch Website",
          desc:
            "Candy ice cream cake. Halvah gummi bears Cupcake gummi bears soufflé caramels candy.",
          time: "25 days ago"
        },
        {
          color: "primary",
          icon: "TvIcon",
          title: "Marketing",
          desc: "Candy ice cream cake. Halvah gummi bears Cupcake gummi bears.",
          time: "28 days ago"
        }
      ],

      analyticsData: analyticsData,
      dispatchedOrders: []
    };
  },
  computed: {
    activeUserInfo() {
      return this.$store.state.AppActiveUser;
    }
  },
  components: {
    VueApexCharts,
    StatisticsCardLine,
    ChangeTimeDurationDropdown,
    VxTimeline,
    LastTransactions
  },
  methods: {
    initSignalR() {
      this.connection = new this.$signalR.HubConnectionBuilder()
        .withUrl("https://api.bistpay.com/signalr")
        .configureLogging(this.$signalR.LogLevel.Information)
        .build();
      this.connection.onclose(() => {
        this.connectToSignalR();
      });
      this.connectToSignalR();
      this.connection.on("getNotification", (message) => {
        console.log(message);
        this.$vs.notify({
          title: "پیام جدید",
          text: message.Notification.Data.Message,
          iconPack: "feather",
          icon: "icon-alert-circle",
          color: "warning"
        });
        //this.messages.push({ text: data.value.text, date: data.value.date });
        //this.$store.getters.needReloadPage;
      });
    },
    connectToSignalR() {
      this.connection.start().catch(err => {
        console.error("Failed to connect with hub", err);
        return new Promise((resolve, reject) =>
          setTimeout(
            () =>
              this.connectToSignalR()
                .then(resolve)
                .catch(reject),
            5000
          )
        );
      });
    },
    closeConnectionSR() {
      if (!this.connection) return;
      this.connection.off("RefreshEvent");
      this.connection = null;
    }
  },
  created() {

     //this.initSignalR();
     
    this.$http
      .get("/api/user/checkpoint-reward")
      .then(response => {
        this.checkpointReward = response.data;
      })
      .catch(error => {
        console.log(error);
      });

    // مشتریان جدید - Statistics
    this.$http
      .get("/api/card/card-statistics/subscribers")
      .then(response => {
        this.subscribersGained = response.data;
      })
      .catch(error => {
        console.log(error);
      });

    // Orders - Statistics
    this.$http
      .get("/api/card/card-statistics/orders")
      .then(response => {
        this.ordersRecevied = response.data;
      })
      .catch(error => {
        console.log(error);
      });

    // Sales bar - Analytics
    this.$http
      .get("/api/card/card-analytics/sales/bar")
      .then(response => {
        this.salesBarSession = response.data;
      })
      .catch(error => {
        console.log(error);
      });

    // پشتیبانی
    this.$http
      .get("/api/card/card-analytics/support-tracker")
      .then(response => {
        this.supportTracker = response.data;
      })
      .catch(error => {
        console.log(error);
      });

    // Products Order
    this.$http
      .get("/api/card/card-analytics/products-orders")
      .then(response => {
        this.productsOrder = response.data;
      })
      .catch(error => {
        console.log(error);
      });

    // Sales Radar
    this.$http
      .get("/api/card/card-analytics/sales/radar")
      .then(response => {
        this.salesRadar = response.data;
      })
      .catch(error => {
        console.log(error);
      });

    // Dispatched Orders
    this.$http
      .get("/api/table/dispatched-orders")
      .then(response => {
        this.dispatchedOrders = response.data;
      })
      .catch(error => {
        console.log(error);
      });

  },
  mounted() {}
};
</script>

<style lang="scss">
/*! rtl:begin:ignore */
#dashboard-analytics {
  .greet-user {
    position: relative;

    .decore-left {
      position: absolute;
      left: 0;
      top: 0;
    }
    .decore-right {
      position: absolute;
      right: 0;
      top: 0;
    }
  }

  @media (max-width: 576px) {
    .decore-left,
    .decore-right {
      width: 140px;
    }
  }
}
/*! rtl:end:ignore */
</style>
